<template>
  <div>
    <header-bar></header-bar>
    <div class="part_1">
      <div class="part_1_content">
        <div class="part_1_t1">关于我们</div>
        <div class="part_1_t2">
          <!-- <span style="color: #f60d11">杭州</span> -->
          般意科技有限公司是由耶鲁精神医学博士后创办，致力于用脑科学前沿科技提升用脑效率的非侵入式脑机接口科技公司。
        </div>
      </div>
    </div>
    <div class="part_2" id="company">
      <div class="part_2_t1">公司发展历程</div>
      <div class="part_2_content">
        <div class="part_2_content1">
          <div class="time_item1">
            <div class="part_2_t5">般意公司成立</div>
            <img
              src="https://static4.coolbrainscience.cn/7fdf02f2e14d4edc897034a332e4a175.png"
              class="time_pic"
            />
          </div>
          <div class="time_item2">
            <div class="part_2_t5">启动脑机接口硬件产品研发</div>
            <img
              src="https://static4.coolbrainscience.cn/1f199b6b1d3044c6aa51263d318a0faf.png"
              class="time_pic"
            />
          </div>
          <div class="time_item5">
            <div class="part_2_t5">销售现象级脑机产品</div>
            <img
              src="https://static4.coolbrainscience.cn/f38992762f4849e78c460cf3ebfc21db.png"
              class="time_pic"
            />
          </div>
        </div>
        <div class="part_2_content2">
          <div class="time_content1">
            <div class="line1"></div>
            <div class="time_block">
              <div class="part_2_t3">2019.07</div>
              <div class="longString1"></div>
            </div>
          </div>
          <div class="time_content1">
            <div class="time_block">
              <div class="part_2_t3">2020.06</div>
              <div class="longString1"></div>
            </div>
            <div class="line2"></div>
          </div>
          <div class="time_content1">
            <div class="time_block">
              <div class="part_2_t3">2021.01</div>
              <div class="longString1"></div>
            </div>
            <div class="line1"></div>
          </div>
          <!-- <div class="time_content2">
            <div class="time_block">
              <div class="part_2_t3">2022.12</div>
              <div class="longString2"></div>
            </div>
            <div class="line2"></div>
          </div> -->
          <div class="time_content1">
            <div class="time_block">
              <div class="part_2_t3">2022.12</div>
              <div class="longString2"></div>
            </div>
            <div class="line2"></div>
          </div>
          <div class="time_content2">
            <div class="time_block">
              <div class="part_2_t3">2023.12</div>
              <!-- <div class="longString2"></div> -->
            </div>
            <div class="line1"></div>
          </div>
        </div>
        <div class="part_2_content3">
          <div class="time_item3">
            <div class="part_2_t5">成立第一家线下咨询中心</div>
            <img
              src="https://static4.coolbrainscience.cn/42d780ded84d410cb710ed8df030353a.png"
              class="time_pic"
            />
          </div>
          <div class="time_item4">
            <div class="part_2_t5">般意精力舱上市</div>
            <img
              src="https://static4.coolbrainscience.cn/036e77f67ae241009b708dee016a1782.png"
              class="time_pic"
            />
          </div>
        </div>
      </div>
      <div class="milestone_new">
        <div
          class="milestone_new_item"
          v-for="item in recentMilestones"
          :key="item.year"
        >
          <div class="part_2_t3">{{ item.year }}</div>
          <div
            class="part_2_t5"
            v-for="(event, index) in item.events"
            :key="index"
          >
            {{ event }}
          </div>
        </div>
      </div>
      <div class="time_content3">
        <div class="social_num1">
          <div class="webo">
            <div class="part_2_t2">141.9万</div>
            <div class="part_2_t4">微博粉丝</div>
          </div>
          <div class="wechat">
            <div class="part_2_t2">20.6万</div>
            <div class="part_2_t4">微信公众号关注量</div>
          </div>
        </div>
        <div class="time_block">
          <img
            src="https://static4.coolbrainscience.cn/bcaba698edd040e498e16dc2733975a1.png"
          />
        </div>
        <div class="social_num2">
          <div class="douyin">
            <div class="part_2_t2">150.7万</div>
            <div class="part_2_t4">抖音粉丝</div>
          </div>
          <div class="xiaohongshu">
            <div class="part_2_t2">10.0万</div>
            <div class="part_2_t4">小红书粉丝</div>
          </div>
        </div>
      </div>
    </div>
    <div class="part_3" id="founder">
      <div class="part_3_left">
        <img
          src="https://static4.coolbrainscience.cn/28842c79157f44ecb8a5ec19a824ccad.png"
          alt=""
        />
      </div>
      <div class="part_3_right">
        <div class="t1">
          公司创始人<span style="color: #888ef9">姚乃琳</span>
        </div>
        <div class="part_3_content">
          <div class="part_3_content1">
            {{ founder.education.join(" · ") }} · {{ founder.sciPapers }} 篇
            学术论文 · {{ founder.followers }}
          </div>
          <div class="part_3_content2">
            从事脑科学研究超过10年，在国际知名SCI期刊发表19篇研究文章，<br />
            研究方向涉及：用最前沿大脑成像手段观测幻觉，精神分裂症，帕金森病等精神，神经，衰<br />老相关疾病。多次参与精神医学领域（Biological
            Psychiatry) 和脑成像领域 (OHBM) 顶会并<br />发表研究分享演讲。
          </div>
        </div>
        <div class="t2">
          近五年，来自著名期刊Nature、JAMA等子刊的网红级别研究成果
        </div>
        <img
          src="https://static4.coolbrainscience.cn/26f4edc3e52a4814b8a3e907c09924e0.png"
          alt=""
        />
      </div>
    </div>
    <!-- <div class="part_3" id="founder">
      <div class="part_3_content">
        <div class="part_3_left">
          <img
            src="https://static4.coolbrainscience.cn/553dbd1a8632459fa83cd66ff07a74c5.png"
          />
        </div>
        <div class="part_3_right">
          <div class="part_3_t1">
            公司创始人
            <div class="part_3_t11">姚乃琳</div>
          </div>
          <div class="part_3_t2">
            <ul>
              <li>前耶鲁大学精神医学博士后</li>
              <li>香港大学精神医学博士</li>
              <li>浙江大学心理学士</li>
            </ul>
            <ul>
              <li>
                从事脑科学研究超过10年，在国际知名SCI期刊发表19篇研究文章，
                研究方向涉及：
              </li>
              <li>- 用最前沿大脑成像手段观测幻觉</li>
              <li>- 精神分裂症</li>
              <li>- 帕金森病等精神</li>
              <li>- 神经</li>
              <li>- 衰老相关疾病</li>
              <li>
                多次参与精神医学领域（Biological Psychiatry) 和脑成像领域 (OHBM)
                顶会并发表研究分享演讲。
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div> -->
    <div class="part_4">
      <div class="part_4_left">
        <div class="part_4_t1">超过150万关注者</div>
        <div class="part_4_t2">
          公司创始人IP为抖音脑科学心理学垂类头部品牌，拥有超过<br />150万关注者。
        </div>
        <a href="https://weibo.com/u/2124970203"
          ><button type="button">去关注</button></a
        >
      </div>
      <div class="part_4_right">
        <img
          src="https://static4.coolbrainscience.cn/6dd237985d4c4079a8a29eedd0e488f0.png"
        />
      </div>
    </div>
    <div class="part_5" id="team">
      <div class="part_5_left">
        <img
          src="https://static4.coolbrainscience.cn/1185ea0c0b30409eaeace6ea01140b93.png"
        />
      </div>
      <div class="part_5_right">
        <div class="t1">我们的<span style="color: #888ef9">团队</span></div>
        <div class="t2" style="margin: 0.83vw 0">
          我们的团队有来自top名校从事脑科学，神经科学，心理学，算法…等方向的专业人才。
        </div>
        <img
          src="https://static4.coolbrainscience.cn/23165fd419f049c287e3d24f59c5d733.png"
          alt=""
        />
        <div class="part_5_content">
          <div class="t2" style="margin-left: 5.26vw">牛津大学</div>
          <div class="t2" style="margin: 0 3.28vw 0 5.47vw">耶鲁大学</div>
          <div class="t2">浙江大学</div>
          <div class="t2" style="margin: 0 2.97vw 0 3.96vw">中科院</div>
          <div class="t2">伦敦大学国王学院</div>
        </div>
      </div>
    </div>
    <div class="part_6" id="comment">
      <div class="t1">positive feedback</div>
      <div class="t2">精力舱好评</div>
      <div class="line"></div>
      <div class="part_6_content">
        <swiper :options="swiperOptions">
          <swiper-slide>
            <div class="part_6_content1">
              <div class="part_6_content11">
                <div class="part_6_title">
                  <img src="../../assets/about7.png" alt="" />
                  <div class="t3">般意用户</div>
                </div>
                <div class="t4">
                  买了精力舱两个多月了，平常大约隔一天用一次，买的目的为了睡眠质量，提高精力。说一下这两个多月的使用感受吧，我平时睡眠不好，半夜一半
                  3、4点醒，醒来后就很难入睡了，使用精力舱初期，最大的感觉就是早上用一下精力舱，就会让一天的精力旺盛，坚持使用两个月后，基本上不会出现醒来再也睡不着的情况，而且睡眠质量也提高了很多，以前如果一天睡6个小时第二天肯定没精神，而现在睡6个小时就能让一天精力充沛。
                </div>
              </div>
              <div class="part_6_content12">
                <div class="part_6_title">
                  <img src="../../assets/about8.png" alt="" />
                  <div class="t3">般意用户</div>
                </div>
                <div class="t4">
                  我把精力舱只给我爸爸用了两次，我爸爸的睡眠就神奇般的变好了，晚上到点儿就闲，睡眠质量变得特别高，他开始完全不相信，但事实就是如此，他后来也不得不开始承认了。
                  后来我又介绍给我一个阿姨用她因为之前工作的原因二十多年睡不着觉，用了两三次就开始睡不醒，现在说记忆力也变好了以前记不清的东西，现在很快能记住了，有点恢复了年轻时超级棒的记忆力。又给我的一个睡眠质量不好，总是多梦的叔叔用，只用了一次叔叔说感觉睡得是好些了。介绍他们使用精力舱的这两个叔叔阿姨都是帮了我家很大忙的恩人，能用精力舱帮助到他们，真的很开心。
                  感谢琳子老师研发出这么好的产品，真的很感恩，遇到琳子老师真的是我莫大的福气了！
                </div>
              </div>
              <div class="part_6_content13">
                <div class="part_6_title">
                  <img src="../../assets/about8.png" alt="" />
                  <div class="t3">般意用户</div>
                </div>
                <div class="t4">
                  精力舱使用有一周年了，前半年我是一周用5次，半年后我的使用频率进行过隔天用和天天用的尝试感觉是进入了一种维稳的状态，隔天用时启动行为和主动专注比天天用还要更容易些，天天用反而没有线性的叠加效果，这一年我破天荒地看了十几本书，有的还二刷，整个过程不再是苦大仇深反而是一种享受，像上高速一样，不仅意愿足而且总结和吸收效率也大大提升尤其是结合买过的课程，二刷基本能赶上以前四五刷才能达到的掌握程度;另外就是坚持使用每隔一段时间，会有不同程度的整体状态的跃迁式的变化，皮肤变好了，整体长相就是照镜子看自己越来越顺眼，身边也有几个主动给过我反馈，说我变得阳光了，变好看了。
                </div>
              </div>
            </div>
            <div class="part_6_content1">
              <div class="part_6_content14">
                <div class="part_6_title">
                  <img src="../../assets/about8.png" alt="" />
                  <div class="t3">般意用户</div>
                </div>
                <div class="t4">
                  我主要给我妈买的，她睡眠越来越不好，已经变成早上才开始真正的睡觉了，完全颠倒了。第一天收到用了15分钟第二天她就说睡得很熟，后来到现在好像都睡得挺好的，很久没有这样了。本来我很担心这样会造成她身体的大问题，没想到现在这么容易的就要解决了很开心
                </div>
              </div>
              <div class="part_6_content15">
                <div class="part_6_title">
                  <img src="../../assets/about7.png" alt="" />
                  <div class="t3">般意用户</div>
                </div>
                <div class="t4">
                  助理老师们好，我反馈一下我最近的感受，我最近突然发现我的情商变高了，我最近很少发火甚至根本就没发火，我以前害怕跟美女说话，现在没那么害怕念人，想说话就说话，而且最近社交当中我的情绪比较稳定，我的症彻底变好了，我以前天天思考活着的意义，我们为什么要活着，越想越，现在已经无所谓了。
                </div>
              </div>
              <div class="part_6_content16">
                <div class="part_6_title">
                  <img src="../../assets/about8.png" alt="" />
                  <div class="t3">般意用户</div>
                </div>
                <div class="t4">
                  我用了三次，做事很麻利，反应也很快，越好做事越起劲，昨天我搬家，整理东西很细节前我不喜欢整理的觉得很头疼.昨天我陈年老旧N年没整理的抽屉都整理的很干净擦的很干净.整理完整个人都感觉焕然一新!感觉很好，用完精力舱就是执行力强了，没有拖延了，不了，马上立刻行动起来了.反应也很快.太好了
                </div>
              </div>
            </div>
            <div class="part_6_content1">
              <div class="part_6_content17">
                <div class="part_6_title">
                  <img src="../../assets/about8.png" alt="" />
                  <div class="t3">般意用户</div>
                </div>
                <div class="t4">
                  好，用了将近14天的精力舱，状态越来越好，大脑反应速度越来快，专注力越来越好，执行力越来越强，脑袋越来越清醒，越来越有活力和动力，相信以后会更好，谢谢琳子老师研发的精力舱，顺便说下我是17的症，今年状态是基本上全部好转的一年，生活工作学习沟通交流都完全没有问题了，但是还不能达到症前的一个状态，所以我买来精力舱，希望用最短的时间，恢复到最佳的状态，状态失之毫米，差之千里。人生不能再因为症而再被耽误了。每天都在用，大部分2档，有时候用了档，希望效果上来的更快。
                </div>
              </div>
              <div class="part_6_content18">
                <div class="part_6_title">
                  <img src="../../assets/about7.png" alt="" />
                  <div class="t3">般意用户</div>
                </div>
                <div class="t4">
                  使用感受分享:使用精力舱三周，一般隔天睡前使用，我的状态已经，晚睡但是睡很香。我调高了档位，能感受到电流像摆钟一样在闹钟随着钟声摆动穿梭过前额。
                  有意思的是，我没有鼻炎，偶尔空调吹多了鼻塞，电流摆过会感到鼻子一下子通了，挺爽的！时间到了，还能感到电流摆动，用个词来形容，参考“余音绕梁”这个是“余点摆脑”?感受着一会就睡着了。行为上，我这几天开始尝试自己做饭看书听课程，不知道跟精力舱使用有没有关系，想做什么愿意去做
                </div>
              </div>
              <div class="part_6_content19">
                <div class="part_6_title">
                  <img src="../../assets/about8.png" alt="" />
                  <div class="t3">般意用户</div>
                </div>
                <div class="t4">
                  上月回家开始，每天早上九点前一次，连续使用半个月，反馈如下配合我二月下旬开始的睡眠管理(23点睡-7点醒)，睡眠质量明显提升:<br />
                  1.自己问自己准备睡觉了吗?到点要睡了，然后就会放下手机，不留恋;<br />
                  2.入睡变容易，以前经常睁眼熬到天亮才能睡，现在入睡时间不超过半小时了.半夜醒来次数变少，以前是睡两三个小时就醒，醒来再也睡不着然后是一夜醒来四五次，每次醒都觉得睡了一个整觉，接着再睡也能睡着，现在是夜里醒来一两次，昨晚一觉到天亮。
                </div>
              </div>
            </div>
            <div class="part_6_content1">
              <div class="part_6_content20">
                <div class="part_6_title">
                  <img src="../../assets/about7.png" alt="" />
                  <div class="t3">般意用户</div>
                </div>
                <div class="t4">
                  了一年多，状态好多了。几次记不清了，一年多以前很丧，现在每天都乐观。容易从负面情绪中调整过来。希望自己越来越缩短调整过来的时间。自己状态能越来越好。
                </div>
              </div>
              <div class="part_6_content21">
                <div class="part_6_title">
                  <img src="../../assets/about7.png" alt="" />
                  <div class="t3">般意用户</div>
                </div>
                <div class="t4">
                  使用的这段时间里最大的感受一是精力比以前变好了，我是易疲劳体质，但是最近即使休息不太好也能在工作中充满精力;二是更容易集中注意力，迅速进入工作状态;三是执行力变强。我本人是大脑不敏感体质，希望在下一阶段的使用中有更好更清晰地体验来反馈。
                </div>
              </div>
              <div class="part_6_content22">
                <div class="part_6_title">
                  <img src="../../assets/about7.png" alt="" />
                  <div class="t3">般意用户</div>
                </div>
                <div class="t4">
                  汇报一下使用情况:1.睡眠:看了下睡眠检测，自己感觉是差不多，但检测显示深度睡眠连续的时间长了些;2.白天精力:今天第二天，明天感觉精力好了很多，以前一到中午哪怕不睡也没精力做事情，今天中午还能额外再增加工作量;3.注意力:能专注的时间更长，比以前高
                </div>
              </div>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="part_6_content1">
              <div class="part_6_content23">
                <div class="part_6_title">
                  <img src="../../assets/about8.png" alt="" />
                  <div class="t3">般意用户</div>
                </div>
                <div class="t4">
                  超级无敌幸运能关注到琳子老师能用到这么棒的产品
                  去年三月份的时候有段时间非常睡不着觉
                  如果一点前睡着了那么三四点就会醒 醒了就睡不着了
                  如果两三点睡的话能睡到六点左右 而且都睡得很浅
                  每天都是带着眼罩和耳塞睡觉 每天都觉得身体很疲惫没有精神
                  后来买了睡眠课程学习让自己多晒晒太阳多运动运动 注意饮食
                  又听了很多琳子老师的直播 慢慢的好了很多
                  直到今年三月份开始用了精力舱 我才开始慢慢没有带耳塞睡觉了
                  开始有了种身体焕然一新的感觉。
                </div>
              </div>
              <div class="part_6_content24">
                <div class="part_6_title">
                  <img src="../../assets/about8.png" alt="" />
                  <div class="t3">般意用户</div>
                </div>
                <div class="t4">
                  用了一周了，第一天使用，用的一档，脑力充足就有所体现了。第四天因工作原因12点睡觉，第二天3点半起床写报告，当天精力还是充沛的，但晚上11点就特困一觉到天亮6点，哈哈，大脑强制关机休息。感觉脑力舱的干预还是有作用的。
                </div>
              </div>
              <div class="part_6_content25">
                <div class="part_6_title">
                  <img src="../../assets/about7.png" alt="" />
                  <div class="t3">般意用户</div>
                </div>
                <div class="t4">
                  我爸爸妈妈都在使用金色版，睡眠质量得到了很大的，新陈代谢能力也变好了
                </div>
              </div>
            </div>
            <div class="part_6_content1">
              <div class="part_6_content26">
                <div class="part_6_title">
                  <img src="../../assets/about7.png" alt="" />
                  <div class="t3">般意用户</div>
                </div>
                <div class="t4">
                  昨天第一次使用了精力舱还是很有效果的。
                  早上使用后，一段时间感觉周围时间变慢，感觉可以捕捉别人的说话行动，听觉味觉敏感了，看东西明亮了一点，自己的语速和行动变快<br />
                  使用后，了个小时感觉心情特别愉悦，做事充满干劲，周末一些平时懒得做的家务也愿意去做了。甚至平时一口不吃的菜，也愿意去尝试下。一天下来，感觉不太想那些让自己或负面的事情了，思考、表达变得更正面了。周六被通知周日要有小加班，自己也没什么负面情绪想法了。
                  给老婆也使用了，老婆平时对孩子比较严厉，有时会对孩子发脾气使用后感觉她对孩子的语气平和了。
                  总之感觉产品还是很有效，甚至有点神奇哒。
                </div>
              </div>
              <div class="part_6_content27">
                <div class="part_6_title">
                  <img src="../../assets/about8.png" alt="" />
                  <div class="t3">般意用户</div>
                </div>
                <div class="t4">
                  使用般意精力舱一代已经4个多月了，基本上都是在早晨使用，使用半个月以后就感觉睡眠质量有变好，入睡困难缓解了很多，早上起来大脑也清醒了很多，不会懵懵的。工作时的状态也更好了，分析事情和统筹规划都更加清晰，可以说是变得“更聪明”了，抗压能力也变得更强，以前觉得是麻烦不可能做到的事情，现在也更有信心去完成。人的精力真的太重要了，精力好一天能做2天的事情，工作效率大大提高，精力不好的话就事倍功半了。所以我推荐你们去使用一下精力舱，真的不是什么智商税，当然要使用恰当，坚持用一段时间，慢慢感受自己的变化吧!
                </div>
              </div>
              <div class="part_6_content28">
                <div class="part_6_title">
                  <img src="../../assets/about8.png" alt="" />
                  <div class="t3">般意用户</div>
                </div>
                <div class="t4">
                  使用般意精力舱8个多月近9个月了，我的使用方法是隔一天用一次，一直在坚持使用。从使用一开始到现在，我的变化真的很明显。学习过程中，记忆力、专注力、理解力逐步提升，记忆力变更强，专注力、理解力更强，这个变化很明显。生活中，认知能力提升，睡眠质量提升，这两点感受明显。以前睡眠质量不算好，现在睡眠质量很好，用了精力舱后情绪也由一开始的偶尔低落变成了现在的平和稳定的情绪状态。以上就是我使用精力舱大半年的变化，真的很感谢精力舱，让我越来越好。
                </div>
              </div>
            </div>
            <div class="part_6_content2">
              <div class="part_6_content29">
                <div class="part_6_title">
                  <img src="../../assets/about7.png" alt="" />
                  <div class="t3">般意用户</div>
                </div>
                <div class="t4">
                  最明显的是精力水平的提高:
                  1.我以前练新的钢琴曲一次性练十分钟左右就会感觉很疲惫，现在可以一直练到我熟悉了为止。2.我以前下一把象棋就感觉脑子转不动了，现在下了两三把也没有这俢瀰瓯疲惫感。3.我以前看书看的脑壳疼，现在看的很轻松。<br />
                  然后是知觉推理能力的提升:
                  我以前走在大街上的时候脑子是处于一片空白的状态的，去到一个新的环境也没有办法快速地对环境做出判断。现在我能观察到的东西变多了。<br />
                  然后是推理能力的提升:
                  我以前接触到新题目的时候脑子一片空白，根本找不到入手点，脑子就像浆糊一样，现在可以比较快速的找到入手点，并且通过这个点慢慢的把题解开。<br />
                  脑子变清晰了: 我是因为有
                  4/5年情绪上很不稳定，很甚至有点才导致我的这些能力下降的这么厉害,在这几年里我感觉我每天脑子都是糊的，就没有清晰过，用了一段时间精力舱之后我发现我的状态在慢慢的恢复，感觉有希望可以回到我之前的那个状态。非常感谢能遇见精力舱，在遇到它之前我觉得我的人生甚至有可能是灰色的。
                </div>
              </div>
            </div>
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
    </div>
    <!-- <div class="part_5" id="device">
      <div class="part_5_content1">
        <div class="part_5_t1">
          公司拥有自主研发非侵入式脑机接口硬件产品“般意精力舱”，用硬科技提升脑力和精力。
        </div>
      </div>
      <div class="part_5_content2">
        <div class="part_5_left">
          <div class="part_5_left1">
            <div class="part_5_item1">
              <img src="../../assets/Icon_BraveWave.png" />
              <div class="part_5_t2">干预刺激 脑电检测</div>
            </div>
            <div
              class="part_5_item2"
              @click="toguid('/mood', 'principles_of_technology')"
            >
              <div class="part_5_t3">了解更多</div>
              <img src="../../assets/icon_more.png" />
            </div>
          </div>
          <div class="part_5_left2">
            <div class="part_5_item1">
              <img src="../../assets/Icon_Charge.png" />
              <div class="part_5_t2">随时随地给大脑充电</div>
            </div>
            <div
              class="part_5_item2"
              @click="toguid('/device', 'usage_scenario')"
            >
              <div class="part_5_t3">了解更多</div>
              <img src="../../assets/icon_more.png" />
            </div>
          </div>
        </div>
        <div class="part_5_longString"></div>
        <div class="part_5_line"></div>
        <div class="part_5_right">
          <div class="part_5_right1">
            <div class="part_5_item1">
              <img src="../../assets/Icon_HCI@.png" />
              <div class="part_5_t2">人体工学设计 高科技超纤材料</div>
            </div>
            <div
              class="part_5_item2"
              @click="toguid('/mood', 'ergonomically_designed')"
            >
              <div class="part_5_t3">了解更多</div>
              <img src="../../assets/icon_more.png" />
            </div>
          </div>
          <div class="part_5_right2">
            <div class="part_5_item1">
              <img src="../../assets/Icon_phone.png" />
              <div class="part_5_t2">智能互联掌握大脑变化</div>
            </div>
            <div
              class="part_5_item2"
              @click="toguid('/device', 'application_program')"
            >
              <div class="part_5_t3">了解更多</div>
              <img src="../../assets/icon_more.png" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="part_6" id="join_us">
      <div class="part_6_t1">加入我们的团队</div>
      <div class="part_6_content">
        <div class="part_6_t2">
          般意科技团队成员是来自于耶鲁大学、美国加州大学圣地亚哥分校、英国牛津大学、英国伦敦国王学院、中科院心理所、复旦大学、浙江大学等等优秀且充满活力的年轻人，大多为脑科学、神经科学，心理学、医学相关硬核科学背景，也有做脑机接口开发的技术宅。
        </div>
        <button type="button" @click="show = !show">联系我们</button>
        <div class="email" v-if="show">
          <p class="email_num" id="email_num">manager@panbrain.com</p>
          <img src="../../assets/icon_Copy.png" @click="copyEmail()" />
        </div>
      </div>
    </div> -->
    <!--<div class="mask" v-if="show">
      <div class="maskContent">
        <img class="maskImg" :src="require('./../../assets/bg.png')" />
        <img class="qrImg" :src="require('./../../assets/down.png')" />
        <img @click="show = false" class="closeImg" :src="require('./../../assets/close.png')" />
        <p class="txt">扫一扫上面的二维码，下载App</p>
      </div>
    </div>-->
    <!--<div class="head">
      <img src="../../assets/logo_black.png" class="title" />
      <p class="subtitle">LOTUS 1</p>
      <p class="slogan1">白天精力好 晚上睡得香</p>
      <p class="slogan2">脑力工作者的健脑神器</p>
      <img src="../../assets/banner_picture.png" class="banner_picture" />
    </div>
    <div class="part_1">
      <p class="part_1_title1">你是否有这些困扰？</p>
      <div class="part_1_content">
        <div class="part_1_content_left">
          <!-- 白天精力不足 -->
    <!--<div class="img1">
            <div class="t">
              <p class="t1">白天精力不足</p>
              <p class="t2">大脑精力浓度不足</p>
            </div>
          </div>-->
    <!-- 工作学习效率低下 -->
    <!--<div class="img2">
            <div class="t">
              <p class="t1">工作学习效率低下</p>
              <p class="t2">脑力低</p>
            </div>
          </div>
        </div>
        <div class="part_1_content_right">-->
    <!-- 睡眠质量差 -->
    <!--<div class="img3">
            <div class="t">
              <p class="t1">睡眠质量差</p>
              <p class="t2">大脑休息深度不足</p>
            </div>
          </div>-->
    <!-- 睡醒后精神不振 -->
    <!--<div class="img4">
            <div class="t">
              <p class="t1">睡醒后精神不振</p>
              <p class="t2">大脑困倦感积累不足额叶兴奋难以入眠</p>
            </div>
          </div>
        </div>
      </div>
      <p class="part_1_title2">那是因为你的大脑“共振”失调，脑力进入恶性循环</p>
    </div>
    <div class="part_2">
      <div class="part_2_title">
        <p class="part_2_title1">随时随地，给大脑充电</p>
        <p class="part_2_title2">
          清晨使用，精力充沛一整天；下午使用，给脑力续航，高效冲刺夜间工作；周末/旅行时使用，唤醒身心平静愉悦的力量。
        </p>
      </div>
    </div>
    <div class="part_3">
      <div class="part_3_content1">
        <img src="../../assets/theory.png" class="img5" />
        <p>使用PanBrain精力舱</p>
        <p>每天仅需15分钟给大脑做个深度重启</p>
      </div>
      <div class="part_3_content2">
        <div class="effect">
          <p class="effect_title">功效原理</p>
          <p style="margin-top: 1vw">
            PanBrain精力舱通过深层脑刺激技术重启大脑可塑性，打通神经元极化通道，通过重建大脑内稳态平衡，达到提升精力，睡眠的持久作用。
          </p>
          <p>
            脑科学顶刊研究证实可持续提升精力和情绪机能，专注力，压缩睡眠时间，显著提升生活和工作品质。
          </p>
        </div>
        <img src="../../assets/theory1.png" class="img6" />
      </div>
      <div class="part_3_content1" style="margin-top: 1.7vw">
        <img src="../../assets/theory_icon_pertcent.png" class="img5" style="height: 6.95vw" />
        <p style="line-height: 6.95vw">10次干预后：</p>
      </div>
      <div class="part_3_content3">
        <p>• 水平下降35%</p>
        <p>• 压力水平下降36%</p>
        <p>• 情绪水平上升34%</p>
      </div>
    </div>
    <div class="part_4">
      <div class="part_4_left">
        <div class="part_4_left1">
          <img src="../../assets/scenes_icon_recommend.png" class="img7" />
          推荐场景
        </div>
        <div class="part_4_left2">
          清晨起床后出门前使用，利用短短的整理和洗漱时间完成一天的精力提升，还可以快速清醒，同时不影响发型，晚上归家后的休息会更加高效有质量
        </div>
      </div>
      <div class="part_4_right">
        <div class="part_4_right1">
          <img src="../../assets/scenes_icon_superman.png" class="img8" />
          超人模式
        </div>
        <div class="part_4_right2">
          如果想要压缩睡眠时间，可以在下午两点后使用，会使入睡时间延后，但是不影响第二天的起床时间，且第二天不会因睡眠时间缩短而精神不济
        </div>
      </div>
    </div>
    <div class="part_5">
      <div class="part_5_1">
        <div class="part_5_content">
          <img src="../../assets/scenes_icon_office.png" class="img9" />
          <p class="part_5_title1">办公室上班</p>
          <p class="part_5_title2">精力充沛</p>
        </div>
      </div>
      <div class="part_5_2">
        <div class="part_5_content">
          <img src="../../assets/scenes_icon_study.png" class="img9" />
          <p class="part_5_title3">居家学习</p>
          <p class="part_5_title4">高效专注</p>
        </div>
      </div>
      <div class="part_5_3">
        <div class="part_5_content">
          <img src="../../assets/scenes_icon_businessTrip.png" class="img9" />
          <p class="part_5_title1">出差</p>
          <p class="part_5_title2">轻巧便携</p>
        </div>
      </div>
      <div class="part_5_4">
        <div class="part_5_content">
          <img src="../../assets/scenes_icon_holiday.png" class="img9" />
          <p class="part_5_title3">周末或旅行</p>
          <p class="part_5_title4">充分休息</p>
        </div>
      </div>
    </div>
    <div class="part_6">
      <p class="part_6_title1">智能化穿戴，你的高科技大脑助手</p>
      <p class="part_6_title2">
        人体工学的设计，高精度的工艺，领先的自研算法，专业的报告分析
      </p>
    </div>
    <div class="part_7">
      <div class="part_7_content">
        <p class="part_7_title1">干预刺激</p>
        <p class="part_7_title2">电极触头+高精度控制电路</p>
        <p class="part_7_title3">
          采用人体工学导电硅胶触头和进口高精度控制电路材料
          ，可以实现非常准确的电流精度。
        </p>
      </div>
    </div>
    <div class="part_8">
      <div class="part_8_content">
        <p class="part_8_title1">脑电检测</p>
        <p class="part_8_title2">金属电极片</p>
      </div>
      <p class="part_8_title3">
        采用核心采集模组配合自研算法技术。通过前额特定区域的脑电波采集，经过特定算法的去噪滤波和脑电频率解析，从而展示出大脑当前的专注状态以及精力程度。
      </p>
    </div>
    <div class="part_9">
      <div class="part_9_content">
        <p class="part_9_title1">智能佩戴检测</p>
        <p class="part_9_title2">智能硬件+自研算法</p>
        <p class="part_9_title3">
          产品自带智能佩戴检测功能，在用户佩戴不佳时，会有语音提示用户校准佩戴。
        </p>
      </div>
    </div>
    <div class="part_10">
      <div class="part_10_content">
        <p class="part_10_title1">人体工学设计</p>
        <p class="part_10_title2">记忆海绵+蛋白皮内衬+可绑带+防滑垫</p>
        <p class="part_10_title3">
          弹性设计，适配多种头围尺寸，贴合人体头部弧度，拥有头部太空舱般的舒适体验，于此同时又能保证佩戴的稳定性。
        </p>
      </div>
    </div>
    <div class="part_11">
      <div class="part_11_content">
        <p class="part_11_title1">高科技超纤材料</p>
        <p class="part_11_title2">超细纤维+智能织法</p>
        <p class="part_11_title3">
          外壳采用高科技超纤维材料，触感轻柔舒适，抗菌耐磨易清洁。
        </p>
      </div>
    </div>
    <div class="part_12">
      <div class="part_12_content">
        <p class="part_12_title1">智能互联掌握大脑变化</p>
        <p class="part_12_title2">蓝牙+应用程序</p>
        <p class="part_12_title3">
          通过产品内置的蓝牙能轻松实现与手机的智能互联，通过手机应用 (般意)
          对产品进行设置和操作，实现产品与消费者的智能互动。并且获取大脑活跃度指标，使用前后状态反馈和个性化用脑建议。
        </p>
      </div>
    </div>
    <div class="part_13">
      <img src="../../assets/panbrain.png" class="img10" />
      <div class="part_13_content">
        <div class="part_13_left">
          <img src="../../assets/logo_black.png" class="img11" />
          <p class="part_13_title1">般意手机应用</p>
          <p class="part_13_title2">
            般意是一款用于辅助硬件智能设备工作的手机应用。您可以轻松的通过装有般意的手机实现对
            PanBrain 旗下智能设备的操作和控制。
          </p>
          <p class="part_13_title3">
            在您使用硬件设备的过程中，般意会实现全程跟踪、辅助和引导以帮助您高效的获得脑力放松体验。与此同时，般意会对您的脑力数据实时分析，生成科学的报告，让您随时随地精准地获悉自己的精神状态，用更饱满的活力面对生活。
          </p>
          <button type="button" class="downBtn" @click="show = true">
            立即下载
          </button>
        </div>
        <div class="part_13_right">
          <img src="../../assets/App_picture_UI.png" class="img12" />
          <div class="download">
            <img src="../../assets/App_badge_downloadApple.png" class="img13" />
            <img src="../../assets/App_badge_downloadAndroid.png" class="img14" />
          </div>
        </div>
      </div>
    </div>-->
    <!--<div class="part_14">
      <div class="part_14_content">
        <p class="part_14_title1">产品佩戴及使用说明</p>
        <div class="pic">
          <div class="part_14_left_content">
            <img
              src="../../assets/video.png"
              class="img15"
              @click="$router.push('/video')"
            />
          </div>
          <div class="part_14_right_content">
            <p class="part_14_title2">时间线</p>
            <ul class="timeLine">
              <li>
                <div class="timeLeft">
                  <p>-</p>
                  拿到产品后的基本检查
                </div>
                <p class="timeRight">00:00</p>
              </li>
              <li>
                <div class="timeLeft">
                  <p>-</p>
                  首次使用前的注意事项
                </div>
                <p class="timeRight">01:20</p>
              </li>
              <li>
                <div class="timeLeft">
                  <p>-</p>
                  使用前的注意事项
                </div>
                <p class="timeRight">01:31</p>
              </li>
              <li>
                <div class="timeLeft">
                  <p>-</p>
                  如何正确佩戴
                </div>
                <p class="timeRight">02:39</p>
              </li>
              <li>
                <div class="timeLeft">
                  <p>-</p>
                  如何正常使用
                </div>
                <p class="timeRight">03:05</p>
              </li>
              <li>
                <div class="timeLeft">
                  <p>-</p>
                  用后清洁及保养
                </div>
                <p class="timeRight">04:21</p>
              </li>
              <li>
                <div class="timeLeft">
                  <p>-</p>
                  如何充电
                </div>
                <p class="timeRight">04:45</p>
              </li>
              <li>
                <div class="timeLeft">
                  <p>-</p>
                  如何下载APP
                </div>
                <p class="timeRight">05:08</p>
              </li>
            </ul>
            <button
              @click="$router.push('/video')"
              type="button"
              class="downBtn"
              style="margin-top: 1.56vw"
            >
              立即观看
            </button>
          </div>
        </div>
      </div>
    </div> -->
    <footer-info></footer-info>
  </div>
</template>
<script>
import footerInfo from "@/components/common/FooterInfo";
import headerBar from "@/components/common/HeaderBar";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import "@/components/common/swiper1.css";
import { founder, milestones } from "@/data/facts";
export default {
  data() {
    return {
      founder,
      show: false,
      swiperOptions: {
        // Swiper 配置
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        // 其他配置...
      },
    };
  },
  computed: {
    recentMilestones() {
      return milestones.filter((item) => Number(item.year) >= 2024);
    },
  },
  components: {
    footerInfo,
    headerBar,
    swiper,
    swiperSlide,
  },
  created() {
    this.$nextTick(() => {
      this.toLocal();
    });
  },
  methods: {
    copyEmail() {
      var email = document.getElementById("email_num").innerText;
      var oInput = document.createElement("input");
      oInput.value = email;
      document.body.appendChild(oInput);
      oInput.select();
      document.execCommand("copy");
      oInput.className = "oInput";
      oInput.style.display = "none";
      alert("复制成功");
    },
    toLocal() {
      let Id = window.sessionStorage.getItem("toId");
      if (Id) {
        let toElement = document.getElementById(Id);
        toElement.scrollIntoView();
      }
    },
    toguid(path, id) {
      var path = path;
      var Id = id;
      window.sessionStorage.setItem("toId", Id);
      this.$router.push(path);
    },
  },
  // destroyed() {
  //   window.sessionStorage.setItem('toId', '')
  // },
};
</script>
<style scoped>
.part_6_content {
  margin-top: 2.08vw;
}
.part_6_content1 {
  display: flex;
  justify-content: center;
  margin-top: 2.5vw;
}
.part_6_content2 {
  margin-top: 2.5vw;
  margin-left: 7.2917vw;
}
.part_6_content11 {
  background: #f3f4fe;
  border-radius: 1.04vw;
  width: 27.5vw;
  height: 19.17vw;
}
.part_6_content12 {
  background: #f3f4fe;
  border-radius: 1.04vw;
  width: 27.5vw;
  height: 25vw;
  margin: 0 1.4583vw;
}
.part_6_content13 {
  background: #f3f4fe;
  border-radius: 1.04vw;
  width: 27.5vw;
  height: 23.54vw;
}
.part_6_content14 {
  background: #f3f4fe;
  border-radius: 1.04vw;
  width: 27.5vw;
  height: 14.79vw;
}
.part_6_content15 {
  background: #f3f4fe;
  border-radius: 1.04vw;
  width: 27.5vw;
  height: 16.25vw;
  margin: 0 1.4583vw;
}
.part_6_content16 {
  background: #f3f4fe;
  border-radius: 1.04vw;
  width: 27.5vw;
  height: 16.25vw;
}
.part_6_content17 {
  background: #f3f4fe;
  border-radius: 1.04vw;
  width: 27.5vw;
  height: 20.625vw;
}
.part_6_content18 {
  background: #f3f4fe;
  border-radius: 1.04vw;
  width: 27.5vw;
  height: 20.625vw;
  margin: 0 1.4583vw;
}
.part_6_content19 {
  background: #f3f4fe;
  border-radius: 1.04vw;
  width: 27.5vw;
  height: 22.08vw;
}
.part_6_content20 {
  background: #f3f4fe;
  border-radius: 1.04vw;
  width: 27.5vw;
  height: 11.875vw;
}
.part_6_content21 {
  background: #f3f4fe;
  border-radius: 1.04vw;
  width: 27.5vw;
  height: 14.79vw;
  margin: 0 1.4583vw;
}
.part_6_content22 {
  background: #f3f4fe;
  border-radius: 1.04vw;
  width: 27.5vw;
  height: 14.79vw;
}
.part_6_content23 {
  background: #f3f4fe;
  border-radius: 1.04vw;
  width: 27.5vw;
  height: 19.17vw;
}
.part_6_content24 {
  background: #f3f4fe;
  border-radius: 1.04vw;
  width: 27.5vw;
  height: 13.33vw;
  margin: 0 1.4583vw;
}
.part_6_content25 {
  background: #f3f4fe;
  border-radius: 1.04vw;
  width: 27.5vw;
  height: 10.42vw;
}
.part_6_content26 {
  background: #f3f4fe;
  border-radius: 1.04vw;
  width: 27.5vw;
  height: 25vw;
}
.part_6_content27 {
  background: #f3f4fe;
  border-radius: 1.04vw;
  width: 27.5vw;
  height: 22.08vw;
  margin: 0 1.4583vw;
}
.part_6_content28 {
  background: #f3f4fe;
  border-radius: 1.04vw;
  width: 27.5vw;
  height: 20.625vw;
}
.part_6_content29 {
  background: #f3f4fe;
  border-radius: 1.04vw;
  width: 27.5vw;
  height: 32.29vw;
}
.part_6_content img {
  width: 4.17vw;
  height: 4.17vw;
}
.part_6_content .t3 {
  color: #333333;
  font-weight: 500;
  font-family: "SourceHanSansCN-Medium";
  font-size: 1.25vw;
  line-height: 4.17vw;
  margin-left: 0.83vw;
}
.part_6_content .t4 {
  width: 25vw;
  color: #333333;
  font-weight: 400;
  font-family: "SourceHanSansCN-Regular";
  font-size: 0.9375vw;
  text-align: justify;
  margin-left: 1.25vw;
}
.part_6_title {
  display: flex;
  margin: 1.25vw 0 0.83vw 1.25vw;
}
.part_1 {
  width: 100vw;
  height: 28.125vw;
  background: url(../../assets/9.png) no-repeat;
  background-size: 100% 100%;
}

.part_1_content {
  padding: 10.83vw 13.28vw 8.33vw 13.28vw;
}

.part_1_t1 {
  color: #333333;
  font-weight: bold;
  font-family: "SourceHanSansCN-Bold";
  font-size: 3.125vw;
}

.part_1_t2 {
  color: #9b9b9b;
  font-weight: 500;
  font-family: "SourceHanSansCN-Medium";
  font-size: 1.67vw;
  margin-top: 1.67vw;
}

.part_2 {
  background: #f3f4fe;
  width: 100vw;
  /* height: 103.6vw; */
  height: auto;
  padding-bottom: 4vw;
  text-align: center;
}

.part_2_t1 {
  padding-top: 3.6vw;
  color: #333333;
  font-weight: bold;
  font-family: "SourceHanSansCN-Bold";
  font-size: 2.19vw;
  margin-bottom: 4.95vw;
}

.part_2_content {
  background: url(../../assets/Milestones.png) no-repeat;
  background-size: 76.3vw 11.9vw;
  background-position: 50% 13.5vw;
}

.part_2_content1,
.part_2_content2,
.part_2_content3 {
  display: inline-block;
  vertical-align: top;
}

.part_2_content1 {
  text-align: right;
}

.part_2_content2 {
  padding: 0 8.13vw;
}

.part_2_content3 {
  text-align: left;
  margin-top: 11.75vw;
}

.time_content1,
.time_content2,
.time_content3 {
  font-size: 0;
  position: relative;
}

.time_content1 {
  padding-bottom: 9.825vw;
}

.time_content2 {
  padding-bottom: 13.285vw;
}

.time_content3 {
  /* margin-top: -3.75vw; */
  /* margin-top: -4.5vw; */
  margin-top: 3.58vw;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* 社交数据火箭：改为文档流布局，避免绝对定位溢出到下一屏 */
.time_content3 .time_block {
  position: static;
  transform: none;
  display: inline-block;
}

.time_content3 .time_block img {
  display: block;
}

.time_content3 .social_num1 {
  margin: 0 4vw 0 0;
  text-align: right;
}

.time_content3 .social_num2 {
  margin: 0 0 0 4vw;
  text-align: left;
}

.line1,
.line2 {
  height: 0.1vw;
  width: 2.92vw;
  background-color: #888ef9;
  display: inline-block;
  margin-top: 1.825vw;
}

.line1 {
  margin-left: -13.37vw;
}

.line2 {
  margin-right: -13.37vw;
}

.time_block {
  display: inline-block;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}

.part_2_t3 {
  width: 10.42vw;
  height: 3.75vw;
  line-height: 3.75vw;
  color: #ffffff;
  font-size: 1.35vw;
  font-weight: 500;
  font-family: "SourceHanSansCN-Medium";
  background-color: #888ef9;
}

.longString2 {
  width: 0.1vw;
  background-color: #888ef9;
  margin: auto;
  height: 11.46vw;
}

.longString1 {
  width: 0.1vw;
  height: 8vw;
  background-color: #888ef9;
  margin: auto;
}

.time_block img {
  width: 16.8vw;
  height: 36.98vw;
}

.social_num1 {
  display: inline-block;
  vertical-align: top;
  margin-top: 3.4vw;
  text-align: right;
  margin-right: 8.4vw;
}

.social_num2 {
  display: inline-block;
  vertical-align: top;
  margin-top: 10.4vw;
  text-align: left;
  margin-left: 8.4vw;
}

.part_2_t2 {
  color: #888ef9;
  font-weight: 500;
  font-family: "SourceHanSansCN-Medium";
  font-size: 1.67vw;
}

.part_2_t4,
.part_2_t5 {
  color: #333333;
  font-weight: 400;
  font-family: "SourceHanSansCN-Normal";
  font-size: 0.9vw;
}

.part_2_t5 {
  line-height: 3.75vw;
}

.wechat {
  margin-top: 8.85vw;
}

.xiaohongshu {
  margin-top: 7.92vw;
}

.time_pic {
  width: 15.625vw;
  height: 15.625vw;
}

.time_item2,
.time_item4,
.time_item5 {
  /* margin-top: 4.125vw; */
  margin-top: 3.8vw;
}

.milestone_new {
  display: flex;
  justify-content: center;
  margin-top: 2.5vw;
}

.milestone_new_item {
  width: 18vw;
  margin: 0 1.5vw;
  text-align: center;
}

.milestone_new_item .part_2_t3 {
  width: 100%;
}

.milestone_new_item .part_2_t5 {
  line-height: 1.8vw;
  margin-top: 1vw;
}

.part_3 {
  width: 100vw;
  min-height: 34.43vw;
  padding: 4vw 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.part_3_left img {
  width: 20.83vw;
  height: 23.8vw;
}
.part_3_right {
  width: 55vw;
  margin-left: 2.5vw;
}
.part_3_right .t1 {
  color: #333333;
  font-size: 2.19vw;
  font-weight: bold;
  font-family: "SourceHanSansCN-Bold";
}
.part_3_right img {
  width: 50.1vw;
  height: 16.4vw;
  margin-top: 0.83vw;
  object-fit: cover;
}
.part_3_content {
  display: block;
  margin: 0.83vw 0;
}
.part_3_content1,
.part_3_right .t2 {
  color: #333333;
  font-weight: 500;
  font-family: "SourceHanSansCN-Medium";
  font-size: 0.94vw;
  line-height: 1.9;
}
.part_3_content2 {
  color: #333333;
  font-size: 0.94vw;
  font-weight: 400;
  font-family: "SourceHanSansCN-Regular";
  line-height: 1.9;
  margin-top: 0.5vw;
}

/** .part_3 {
  width: 100vw;
  height: 33.33vw;
  background-color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
}

.part_3_content,
.part_4_content {
  display: flex;
  justify-content: center;
  align-items: center;
}

.part_3_right {
  width: 28.6vw;
  margin-left: 13.4vw;
}

.part_3_left img {
  width: 26.35vw;
  height: 30.36vw;
}

.part_3_t1,
.part_4_t1 {
  color: #333333;
  font-weight: bold;
  font-family: "SourceHanSansCN-Bold";
  font-size: 2.19vw;
}

.part_3_t11 {
  color: #888ef9;
  display: inline-block;
}

.part_3_t2,
.part_4_t2 {
  color: #333333;
  font-family: "SourceHanSansCN-Normal";
  font-weight: 400;
  font-size: 0.9vw;
}

.part_3_t2 ul {
  margin: 1.25vw 0;
  padding: 0;
  list-style-type: none;
}*/

.part_4 {
  width: 100vw;
  height: 27.29vw;
  display: flex;
  justify-content: center;
  align-items: center;
}

.part_4_t1 {
  color: #333333;
  font-weight: bold;
  font-family: "SourceHanSansCN-Bold";
  font-size: 2.19vw;
}

.part_4_t2 {
  color: #333333;
  font-weight: 400;
  font-family: "SourceHanSansCN-Regular";
  font-size: 0.9vw;
}

.part_4_right img {
  width: 22.6vw;
  height: 22.29vw;
  margin-left: 11.875vw;
}

.part_4_t2 {
  margin-top: 0.83vw;
  margin-bottom: 2.08vw;
}

.part_4_left button {
  width: 10vw;
  height: 3vw;
  border-radius: 0.3vw;
  background: #888ef9;
  color: #ffffff;
  font-weight: 400;
  font-family: "SourceHanSansCN-Regular";
  font-size: 0.9vw;
  border: none;
}

.part_5 {
  width: 100vw;
  height: 23.94vw;
  display: flex;
  align-items: center;
  justify-content: center;
}
.part_5_left img {
  width: 26.85vw;
  height: 18.94vw;
  margin-right: 2.5vw;
}
.part_5_right .t1 {
  color: #333333;
  font-size: 2.1875vw;
  font-weight: bold;
  font-family: "SourceHanSansCN-Bold";
}
.part_5_right .t2 {
  color: #333333;
  font-weight: 400;
  font-family: "SourceHanSansCN-Regular";
  font-size: 0.9375vw;
}
.part_5_right img {
  width: 42.83vw;
  height: 6.715vw;
}
.part_5_content {
  display: flex;
  justify-content: center;
}

.part_6 {
  width: 100vw;
  height: 111.35vw;
  text-align: center;
}
.part_6 .t1 {
  margin-top: 4.58vw;
  text-transform: uppercase;
  background: linear-gradient(349.7601927361714deg, #162f60 0%, #6b7cb5 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 1.458vw;
  font-weight: 300;
  font-family: "SourceHanSansCN-Light";
  letter-spacing: 0.625vw;
}
.part_6 .t2 {
  background: linear-gradient(349.7601927361714deg, #162f60 0%, #6b7cb5 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 3.125vw;
  font-weight: bold;
  font-family: "SourceHanSansCN-Bold";
  margin: 1.25vw 0;
}
.part_6 .line {
  background: linear-gradient(96deg, #819feb 0%, rgba(194, 204, 225, 0) 100%);
  border-radius: 2.5vw;
  width: 4.8958vw;
  height: 0.2083vw;
  margin: auto;
}

/**.part_5 {
  width: 100vw;
  background-color: #ffffff;
  text-align: center;
}

.part_5_content1 {
  width: 73.44vw;
  height: 39.58vw;
  background: url(../../assets/10.png) no-repeat;
  background-size: 100% 100%;
  margin: auto;
  text-align: justify;
}

.part_5_t1 {
  color: #ffffff;
  font-weight: 300;
  font-family: "SourceHanSansCN-Light";
  font-size: 1.67vw;
  padding-top: 8vw;
  padding-left: 8.85vw;
  width: 26.6vw;
}

.part_5_content2 {
  width: 60.9vw;
  height: 27.5vw;
  background: #ffffff;
  display: inline-block;
  margin-top: -13.6vw;
  overflow: hidden;
  margin-bottom: 6.5vw;
  box-shadow: 0 1vw 1vw #d4d8e2;
  position: relative;
}

.part_5_left {
  display: inline-block;
  vertical-align: top;
  margin-top: 4.74vw;
  margin-right: 4.2vw;
}

.part_5_longString {
  width: 0.05vw;
  height: 100%;
  background-color: #dbdee5;
  margin: auto;
  display: inline-block;
}

.part_5_line {
  width: 60.9vw;
  height: 0.05vw;
  background-color: #dbdee5;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

.part_5_right {
  display: inline-block;
  vertical-align: top;
  margin-top: 4.74vw;
  margin-left: 2.5vw;
}

.part_5_item1 {
  color: #333333;
  font-size: 1.67vw;
  font-weight: 500;
  font-family: "SourceHanSansCN-Medium";
  overflow: hidden;
}

.part_5_item1 img {
  width: 3.85vw;
  height: 3.85vw;
  float: left;
}

.part_5_t2 {
  float: left;
  line-height: 3.85vw;
  margin-left: 1.67vw;
}

.part_5_item2 {
  color: #888ef9;
  font-size: 0.8vw;
  font-weight: 500;
  font-family: "SourceHanSansCN-Medium";
  overflow: hidden;
  margin-top: 0.73vw;
  margin-left: 5.52vw;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.part_5_t3 {
  float: left;
}

.part_5_item2 img {
  width: 0.83vw;
  height: 0.83vw;
  float: left;
  margin-left: 0.42vw;
}

.part_5_left2,
.part_5_right2 {
  margin-top: 7.5vw;
}

.part_6 {
  width: 100vw;
  height: 23vw;
}

.part_6_t1 {
  color: #333333;
  font-size: 2.19vw;
  font-weight: bold;
  font-family: "SourceHanSansCN-Bold";
  margin-top: 2.71vw;
  margin-bottom: 3vw;
  text-align: center;
}

.part_6_content {
  color: #333333;
  font-size: 0.9vw;
  font-weight: 400;
  font-family: "SourceHanSansCN-Normal";
  width: 73.4vw;
  margin: auto;
  text-align: center;
}

.part_6_t2 {
  text-align: left;
}

.part_6_content button {
  width: 18.75vw;
  height: 3.125vw;
  background: #888ef9;
  border: none;
  border-radius: 0.3vw;
  color: #ffffff;
  font-size: 0.9vw;
  font-weight: 400;
  font-family: "SourceHanSansCN-Regular";
  margin-top: 2.9vw;
  margin-bottom: 0.4vw;
}

.email {
  background-color: #f3f4fe;
  width: 18.75vw;
  height: 2.92vw;
  color: #333333;
  font-size: 0.9vw;
  font-weight: 400;
  font-family: "SourceHanSansCN-Normal";
  overflow: hidden;
  position: relative;
  margin: auto;
}

.email p {
  margin: 0;
}

.email_num {
  float: left;
  padding-left: 1.25vw;
  line-height: 2.92vw;
}

.email img {
  width: 1.25vw;
  height: 1.25vw;
  float: right;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 1.25vw;
}*/
</style>



// WEBPACK FOOTER //
// src/components/pages/Home.vue